import axios from '@sas/nova-core/axios';
import { getLogger } from '@sas/nova-core/logging';

import {
  User as iUser,
  UserMediaTypeJSONValue,
} from '../../../sonder/rest/representations/identities/identities';

import { User as rUser } from '../../representations/common';

// eslint-disable-next-line @sas/i18n/jsx-to-localize
const logger = getLogger('DataSelection');

export const GetUser = async (userID: string): Promise<[rUser | undefined, Error?]> => {
  let response;
  try {
    response = await axios({
      method: 'GET',
      url: `/identities/users/${userID}`,
      headers: {
        Accept: UserMediaTypeJSONValue,
      },
    });
  } catch (error: any) {
    logger.debug(`GetUser(${userID}) error: ${error}`);
    return [undefined, error];
  }

  const user = response.data as iUser;
  return [userToUser(user), undefined];
};

const userToUser = (user: iUser): rUser | undefined => {
  if (!user) {
    return undefined;
  }
  return {
    id: user.id,
    name: user.name,
    title: user.title,
  };
};
